import IFellowshipPost from "../../interfaces/IFellowshipPost";
import IApiResponse from "../../interfaces/IApiResponse";
import SuccessApiResponse from "../../data/SuccessApiResponse";
import { IFellowshipPostService } from "../FellowshipPostService";
import SQLiteHelperService from "../SQLiteHelperService";
import { SQLiteTables } from "../../data/SQLiteTables";
import SQLiteDB from "../../data/SQLiteDB";
import ISQLiteResponse from "../../interfaces/ISQLiteResponse";

const dbFailedResponse = Promise.resolve({
    Data: undefined,
    Success: false,
    Message: { UserMessage: 'db not connected', ServerMessage: 'db not connected' }});

const FellowshipPostServiceHybrid: IFellowshipPostService = {
    createFellowshipPost: async (fellowshipPost) => {
        const newFellowshipPost: any  = {...fellowshipPost};
        //delete newFellowshipPost.id;
        const query = SQLiteHelperService.insertQuery(SQLiteTables.fellowshipPosts, newFellowshipPost);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipPost>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                    fellowshipPost.id = result.insertId.toString();
                    const response = {...SuccessApiResponse, Data: fellowshipPost};
                    response.Message.UserMessage = 'SUCCESS: ADDED NEW POST.';
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: fellowshipPost,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IFellowshipPost>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getFellowshipPost: async (fellowshipPostId) =>  {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipPosts} WHERE \`id\`=${fellowshipPostId}`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipPost>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                if(result.rows.length) {
                    const fellowshipPost = SQLiteHelperService.convertToJsTypes(result.rows.item(0));
                    console.log('sql fellowshipPost: ', fellowshipPost)
                    return  {...SuccessApiResponse, Data: fellowshipPost};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND POST', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IFellowshipPost>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getAllFellowshipPosts: async () => {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipPosts} ORDER BY \`sortDate\` DESC`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipPost[]>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                return  {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(result, true) as IFellowshipPost[]};
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IFellowshipPost[]>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getAllGroupFellowshipPosts: async (groupId: string) => {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipPosts} WHERE groupId = '${groupId}' ORDER BY \`sortDate\` DESC`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipPost[]>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                return  {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(result, true) as IFellowshipPost[]};
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IFellowshipPost[]>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getLastSortDate: async (groupId: string) => {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipPosts} WHERE groupId = '${groupId}' ORDER BY \`sortDate\` DESC`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<Date>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                const posts = SQLiteHelperService.queryResultToArray(result, true) as IFellowshipPost[]
                if(posts && posts.length) {
                    const lastSortDate = posts[0].sortDate;
                    return  {...SuccessApiResponse, Data: lastSortDate ? lastSortDate : new Date(0)} as IApiResponse<Date>;
                } else {
                    return {
                        Data: new Date(0),
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND POST', ServerMessage: 'FAILED TO GET' }
                    } as IApiResponse<Date>
                }
            }).catch((error)=>{
                const response = {
                    Data: new Date(0),
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<Date>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getLastModifiedDate: async (groupId: string) => {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipPosts} WHERE groupId = '${groupId}' ORDER BY \`modifiedDate\` DESC`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<Date>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                const posts = SQLiteHelperService.queryResultToArray(result, true) as IFellowshipPost[]
                if(posts && posts.length) {
                    const lastModifiedDate = posts[0].modifiedDate;
                    return  {...SuccessApiResponse, Data: lastModifiedDate ? lastModifiedDate : new Date(0)} as IApiResponse<Date>;
                } else {
                    return {
                        Data: new Date(0),
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND POST', ServerMessage: 'FAILED TO GET' }
                    } as IApiResponse<Date>
                }
            }).catch((error)=>{
                const response = {
                    Data: new Date(0),
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<Date>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getOlderPosts: async (groupId: string, lastSortDate: Date, limit: number) => {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipPosts} WHERE groupId = '${groupId}' AND \`sortDate\` < ${lastSortDate.getTime()} ORDER BY \`sortDate\` DESC LIMIT ${limit}`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipPost[]>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipPost>)=>{
                return  {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(result, true) as IFellowshipPost[]};
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IFellowshipPost[]>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    updateFellowshipPost: async (fellowshipPost) => {
        const updatedFellowshipPost = {...fellowshipPost};

        const query = SQLiteHelperService.replaceQuery(SQLiteTables.fellowshipPosts, updatedFellowshipPost);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipPost>> = db.executeSql(query, []).then((result)=>{
                    const response = {...SuccessApiResponse, Data: fellowshipPost};
                    response.Message.UserMessage = 'SUCCESS: UPDATED POST.';
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: fellowshipPost,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IFellowshipPost>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    updateFellowshipPosts: async (fellowshipPosts) => {
        const queryArray = fellowshipPosts.map(fellowshipPost => SQLiteHelperService.replaceQuery(SQLiteTables.fellowshipPosts, fellowshipPost));
        const db = await SQLiteDB();
        console.log(queryArray);
        if(db) {
            const dbResponse: Promise<IApiResponse<boolean>> = db.sqlBatch(queryArray).then((result)=>{
                    console.log(result);
                    return {...SuccessApiResponse, Data: true};
            }).catch((error)=>{
                const response = {
                    Data: false,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<boolean>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    // This is no longer used so that syncing with the cloud will know to remove it from other devices
    deleteFellowshipPost: async (fellowshipPost) => {

        const query = `DELETE FROM ${SQLiteTables.fellowshipPosts} WHERE \`id\`=${fellowshipPost.id}`
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<boolean>> = db.executeSql(query, []).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            }).catch((error)=>{
                const response = {
                    Data: false,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<boolean>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },
}

export default FellowshipPostServiceHybrid;